<mat-sidenav-container class="sidenav-container">
	<mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile"
		[class.collapsed]="!isMobile && collapsed" class="custom-sidenav">

		<app-teacher-sidenavbar [collapsed]="collapsed" (toggle)="toggleSidenav()" (routeSelected)="closeSidenav()">
		</app-teacher-sidenavbar>
	</mat-sidenav>

	<mat-sidenav-content [ngStyle]="{ 'margin-left': isMobile ? '0' : (collapsed ? '4.5rem' : '15rem') }">
		<button mat-icon-button *ngIf="isMobile" (click)="sidenav.toggle()" class="mobile-menu-btn">
			<mat-icon>menu</mat-icon>
		</button>

		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>